/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentUserIsLoggedIn = (state, payload) => {
  state.commit("SET_CURRENT_USER_IS_LOGGED_IN", payload);
};

/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentUserInfo = (state, payload) => {
  state.commit("SET_CURRENT_USER_INFO", payload);
};
/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentShippingAdress = (state, payload) => {
  state.commit("SET_CURRENT_SHIPPING_ADRESS", payload);
};
/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentBillingAdress = (state, payload) => {
  state.commit("SET_CURRENT_BILLING_ADRESS", payload);
};
/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentUser = (state, payload) => {
  state.dispatch("setCurrentUserInfo", payload);
  state.dispatch("setCurrentShippingAdress", payload);
  state.dispatch("setCurrentBillingAdress", payload);
};

export default {
  setCurrentUserIsLoggedIn,
  setCurrentUserInfo,
  setCurrentUser,
  setCurrentShippingAdress,
  setCurrentBillingAdress,
};
